export const ACCESS_TOKEN_COOKIE = "ftk_access_token";
export const REFRESH_TOKEN_COOKIE = "ftk_refresh_token";
export const LOGIN_AT_COOKIE = "ftk_login_at";
export const USER_ID_COOKIE = "ftk_user_id";
export const USER_EMAIL_COOKIE = "ftk_user_email";
export const USER_NAME_COOKIE = "ftk_user_name";
export const USER_IMAGE_COOKIE = "ftk_user_image";
export const USER_PROVIDER_COOKIE = "ftk_user_provider";

export function readCookie(name: string): string {
  if (typeof document === "undefined") {
    return "";
  }
  const prefix = `${name}=`;
  const entries = document.cookie.split(";");
  for (const raw of entries) {
    const entry = raw.trim();
    if (entry.startsWith(prefix)) {
      return decodeURIComponent(entry.slice(prefix.length));
    }
  }
  return "";
}

export function clearSessionCookies(): void {
  if (typeof document === "undefined") return;
  const cookies = [
    ACCESS_TOKEN_COOKIE,
    REFRESH_TOKEN_COOKIE,
    LOGIN_AT_COOKIE,
    USER_ID_COOKIE,
    USER_EMAIL_COOKIE,
    USER_NAME_COOKIE,
    USER_IMAGE_COOKIE,
    USER_PROVIDER_COOKIE,
  ];
  for (const name of cookies) {
    document.cookie = `${name}=; Max-Age=0; path=/`;
  }
}

export function writeSessionCookies(payload: {
  accessToken: string;
  refreshToken?: string;
  userID: string;
  email: string;
  name?: string;
  image?: string;
  provider?: "google" | "email";
}): void {
  if (typeof document === "undefined") return;
  const base = "path=/; SameSite=Lax";
  const secure = window.location.protocol === "https:" ? "; Secure" : "";
  document.cookie = `${ACCESS_TOKEN_COOKIE}=${encodeURIComponent(payload.accessToken)}; ${base}${secure}`;
  if (payload.refreshToken) {
    document.cookie = `${REFRESH_TOKEN_COOKIE}=${encodeURIComponent(payload.refreshToken)}; ${base}${secure}`;
  }
  document.cookie = `${USER_ID_COOKIE}=${encodeURIComponent(payload.userID)}; ${base}${secure}`;
  document.cookie = `${USER_EMAIL_COOKIE}=${encodeURIComponent(payload.email)}; ${base}${secure}`;
  document.cookie = `${USER_NAME_COOKIE}=${encodeURIComponent(payload.name ?? payload.email)}; ${base}${secure}`;
  document.cookie = `${USER_IMAGE_COOKIE}=${encodeURIComponent(payload.image ?? "")}; ${base}${secure}`;
  if (payload.provider) {
    document.cookie = `${USER_PROVIDER_COOKIE}=${encodeURIComponent(payload.provider)}; ${base}${secure}`;
  }
}

// markLoginTime records when the session started, so an absolute session cap can be
// enforced independent of token refreshes. Call only on an actual sign-in, not on every
// token refresh, or the cap would never fire.
export function markLoginTime(): void {
  if (typeof document === "undefined") return;
  const base = "path=/; SameSite=Lax";
  const secure = window.location.protocol === "https:" ? "; Secure" : "";
  document.cookie = `${LOGIN_AT_COOKIE}=${Date.now()}; ${base}${secure}`;
}
